<icc-list 
    (select)="selectSystem($event)"  
    [selected]="(selectedSystem$ | async)?.id" 
    itemTemplate="itemImgTitle" 
    itemImgHeight="medium"
    [items]='systems'>
</icc-list>
